// src/main.tsx
import React from "react";
import ReactDOM from "react-dom/client";
import "antd/dist/reset.css";
import "./index.css";
import "@mdxeditor/editor/style.css";
import { App } from "./App";
import { initKeycloak } from "./keycloak";
import { SnackbarProvider } from "notistack";
import { NotistackBridge } from "./notifications/NotistackBridge";
import "./varconfig"; // just importing this validates everything

initKeycloak().then(() => {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <SnackbarProvider
        maxSnack={3}
        autoHideDuration={4000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <NotistackBridge />
        <App />
      </SnackbarProvider>
    </React.StrictMode>,
  );
});
